import {FlexibleTextImage} from '@smart/editorial-components';
import type {FlexibleTextAndImageContent} from '@smart/website-aem-utils';
import {createLegalDisclaimerProps} from '@smart/website-aem-utils';
import * as React from 'react';
import {useFeatureServices} from '../hooks/use-feature-services';
import {useLink} from '../hooks/use-link';

export interface FlexibleTextAndImageWrapperProps {
  readonly content: FlexibleTextAndImageContent;
}

export const FlexibleTextAndImageWrapper = React.memo(
  ({content}: FlexibleTextAndImageWrapperProps) => {
    const {historyService} = useFeatureServices();
    const primaryLink = useLink(content.primaryLink);
    const secondaryLink = useLink(content.secondaryLink);

    const {
      componentHeadline,
      headline,
      priceTag,
      copyText,
      image,
      imageLeading,
      highlight,
      legalDisclaimers,
      indicatorBar,
    } = content;

    return (
      <FlexibleTextImage
        componentHeadline={componentHeadline}
        headline={headline}
        priceTag={priceTag}
        copyText={copyText}
        image={image}
        primaryLink={primaryLink}
        link={secondaryLink}
        imageLeading={imageLeading}
        highlight={highlight}
        legalDisclaimers={createLegalDisclaimerProps(
          legalDisclaimers,
          historyService,
        )}
        indicatorBar={indicatorBar}
      />
    );
  },
  (prevProps, nextProps) => prevProps.content.id === nextProps.content.id,
);

FlexibleTextAndImageWrapper.displayName = `FlexibleTextAndImageWrapper`;
